// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 新增分类
 * @param data
 */
export function addCategroy(data) {
  return request({
    url: '/admin/category/save',
    method: 'POST',
    data: data
  });
}

/**
 * 分类详情
 * @param pram
 */
export function infoCategroy(pram) {
  var data = {
    id: pram.id
  };
  return request({
    url: '/admin/category/info',
    method: 'GET',
    params: data
  });
}

/**
 * 删除分类
 * @param pram
 */
export function deleteCategroy(pram) {
  var data = {
    id: pram.id
  };
  return request({
    url: '/admin/category/delete',
    method: 'GET',
    params: data
  });
}

/**
 * 分类列表
 * @param pram
 */
export function listCategroy(pram) {
  var data = {
    limit: pram.limit,
    name: pram.name,
    page: pram.page,
    pid: pram.pid,
    status: pram.status,
    type: pram.type,
    platformId: pram.platformId
  };
  return request({
    url: '/admin/category/list',
    method: 'GET',
    params: data
  });
}

/**
 * 分类数据tree数据
 * @param pram
 */
export function treeCategroy(pram) {
  var data = {
    type: pram.type,
    status: pram.status,
    name: pram.name,
    platformId: pram.platformId
  };
  return request({
    url: '/admin/category/list/tree',
    method: 'GET',
    params: data
  });
}

/**
 * 获取京东分类列表
 */
export function jdCateLists(params) {
  return request({
    url: '/admin/fusiling/jd/category/list',
    method: 'GET',
    params: params
  });
}

/**
 * 京东商品-修改分类状态
 */
export function changeJdCateState(params) {
  var cateId = params.cateId,
    status = params.status;
  return request({
    url: "/admin/fusiling/jd/category/status/".concat(cateId, "/").concat(status),
    method: 'POST',
    params: params
  });
}

/**
 * 京东分类绑定展示分类
 */
export function jdBindCate(data) {
  return request({
    url: '/admin/fusiling/jd/category/bind/add',
    method: 'post',
    data: data
  });
}

/**
 * 导入分类
 */
export function importCate(data) {
  return request({
    url: '/admin/fusiling/jd/category/inport',
    method: 'post',
    data: data
  });
}

/**
 * 京东分类绑定展示分类-详情
 */
export function jdBindDetail(params) {
  return request({
    url: '/admin/fusiling/jd/category/bind/detail',
    method: 'post',
    params: params
  });
}

/**
 * 京东分类-同步分类
 */
export function syncJdCate() {
  return request({
    url: '/admin/fusiling/jd/category/sync/category',
    method: 'get'
  });
}

/**
 * 更新分类
 * @param data
 */
export function updateCategroy(data) {
  return request({
    url: '/admin/category/update',
    method: 'POST',
    data: data
  });
}

/**
 * 根据id集合查询对应分类列表
 * @param pram
 */
export function categroyByIds(pram) {
  var data = {
    ids: pram.ids
  };
  return request({
    url: '/admin/category/list/ids',
    method: 'GET',
    params: data
  });
}

/**
 * 修改 显示关闭状态
 * @param pram
 */
export function categroyUpdateStatus(id) {
  return request({
    url: "/admin/category/updateStatus/".concat(id),
    method: 'GET'
  });
}

/**
 * 文章详情
 * @param pram
 */
export function articleInfoApi(params) {
  return request({
    url: "/admin/article/info",
    method: 'GET',
    params: params
  });
}

/**
 *获取分类编码
 */
export function generateCateCodeApi(data) {
  return request({
    url: "/admin/generator/generateCateCode",
    method: 'POST',
    data: data
  });
}

/**
 * 获取运营平台列表
 * @param params
 */
export function getPlatformOptions(params) {
  return request({
    url: '/admin/companyapp/autoList',
    method: 'GET',
    params: params
  });
}